import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, Form, FormGroup, Label, Input } from "reactstrap";
import { Calendar } from "react-date-range";
import { enGB, gu, srLatn } from "date-fns/locale";
import { format } from "date-fns";
import { setHours, setMinutes, setSeconds, setMilliseconds } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import "./modals.css"
import "../../Pages/pages.css"
import apiRequest from "../../api";
import TermsModal from "./TermsModalPDFJS";
import PricingModal from "./PricingModal";



const GuestReservationModal = ({
    isOpen,
    toggle,
    fetchReservations,
    selectedDate,
}) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return localStorage.getItem('Language') || 'RS'; // Default to Serbian for guests
    });
    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
    const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
    useEffect(() => {
        setSelectedLanguage(localStorage.getItem('Language') || 'RS');
    }, [isOpen]);
    const locale = selectedLanguage === 'RS' ? srLatn : enGB;
    const calendarRef = useRef(null);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);


    // Check if we're on Safari macOS
    const isSafariMacOS = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
        const isMac = userAgent.includes('macintosh') || userAgent.includes('mac os x');
        return isSafari && isMac;
    };

    const [formDetails, setFormDetails] = useState(() => {
        return {
            date: selectedDate,
            start: "",
            end: "",
            name: "",
            guestEmail: "",
            id: "",
            notes: "",
        };
    });
    const [errors, setErrors] = useState({
        start: "",
        end: "",
        name: "",
        message: "",
        guestEmail: "",
    });
    const toggleModal = (date) => {
        setFormDetails({
            date: selectedDate,
            start: "",
            end: "",
            name: "",
            guestEmail: "",
            id: "",
            notes: "",
        });
        setErrors({
            start: "",
            end: "",
            name: "",
            message: "",
            guestEmail: "",
        });
        toggle();
    };
    useEffect(() => {
        setFormDetails((prevFormDetails) => ({
            ...prevFormDetails,
            date: selectedDate,
        }));
    }, [selectedDate])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {
            start: formDetails.start === "" ? (selectedLanguage === "EN" ? "This field is required" : "Ovo polje je obavezno") : "",
            end: formDetails.end === "" ? (selectedLanguage === "EN" ? "This field is required" : "Ovo polje je obavezno") : "",
            name: formDetails.name === "" ? (selectedLanguage === "EN" ? "This field is required" : "Ovo polje je obavezno") : "",
            guestEmail: formDetails.guestEmail === "" ? (selectedLanguage === "EN" ? "This field is required" : "Ovo polje je obavezno") : "",
        };
        setErrors({
            ...newErrors
        });

        if (newErrors.start || newErrors.end || newErrors.name || newErrors.guestEmail) {
            return;
        }

        // Convert the form details

        const startTime = `${format(formDetails.date, "yyyy-MM-dd")}T${formDetails.start}`;
        const endTime = `${format(formDetails.date, "yyyy-MM-dd")}T${formDetails.end}`;
        // Create the request body for guest (same logic as before for now)
        const requestBody = {
            startTime: startTime,
            endTime: endTime,
            name: formDetails.name,
            notes: formDetails.notes || "",
            guestEmail: formDetails.guestEmail,
            language: selectedLanguage === "EN" ? "en" : "rs", // Convert to lowercase
        };

        // Make the POST request (using same API for now)
        try {
            const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
            const response = await apiRequest('/api/reservations/guestReservationEnquiry', 'POST', requestBody, token);
            fetchReservations();
            toggleModal(); // Close the modal after successful submission
            console.log("Reservation successful:", response);

        } catch (error) {
            try {
                // Parse the error message
                const errorData = JSON.parse(error.message);
                if (errorData.Body && errorData.Body.error) {
                    window.alert(errorData.Body.error); // Display the error message
                }
            } catch (parseError) {
                console.error("Failed to parse error message:", parseError);
            }
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                calendarRef.current &&
                !calendarRef.current.contains(event.target) // Check if click is outside
            ) {
                setIsCalendarOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleInputChange = (e, field) => {
        const { name, value } = e.target;

        setFormDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
            // Reset end time if start time is changed and end is before or equal to start
            ...(name === "start" && prevDetails.end && prevDetails.end <= value ? { end: "" } : {}),
        }));
    };

    return (
        <>
        <Modal isOpen={isOpen} toggle={toggleModal} className="custom-model">
            <ModalBody className="modal-content" id="style-10" style={{ backgroundColor: "#f5f5f5"}}>
                <Form>

                    <div className="row justify-content-center mb-2"  >
                        <div className="col-md-6" ref={calendarRef}>
                            <FormGroup className="modal-date">
                                <Label>
                                    {selectedLanguage === "EN" ? "Date" : "Datum"}
                                </Label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    value={format(formDetails.date, "dd.MM.yyyy")}
                                    onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                                    readOnly
                                    style={{ cursor: "pointer", borderRadius: 5 }}
                                />
                                <div className="calendar-container">
                                    {isCalendarOpen && (
                                        <Calendar
                                            date={formDetails.date}
                                            onChange={(date) => {
                                                setFormDetails((prevDetails) => ({
                                                    ...prevDetails,
                                                    date: date, // Update the date
                                                }));
                                                setIsCalendarOpen(false);
                                            }}
                                            locale={locale}
                                            color="rgba(13, 114, 72, 0.4)"
                                            className="calendar-container"
                                            style={{
                                                '--rdrDayToday-border-color': 'green',
                                            }}
                                        />
                                    )}
                                </div>
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Start" : "Početak"}
                                </Label>
                                <Input
                                    type="select"
                                    name="start"
                                    value={formDetails.start}
                                    onChange={handleInputChange}
                                    className={`form-control ${errors.start ? "input-error" : ""}`}
                                    style={{
                                        fontSize: '14px',
                                        height: '45px',
                                        textAlign: 'center',
                                        textAlignLast: 'center'
                                    }}
                                >
                                    <option value="">
                                        { }
                                    </option>
                                    {Array.from({ length: 11 }, (_, i) => {
                                        const hour = i + 8;
                                        const timeValue = `${hour.toString().padStart(2, '0')}:00`;
                                        return (
                                            <option key={timeValue} value={timeValue}>
                                                {timeValue}
                                            </option>
                                        );
                                    })}
                                </Input>
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "End" : "Kraj"}
                                </Label>
                                <Input
                                    type="select"
                                    name="end"
                                    value={formDetails.end}
                                    onChange={handleInputChange}
                                    className={`form-control ${errors.end ? "input-error" : ""}`}
                                    style={{
                                        fontSize: '14px',
                                        height: '45px',
                                        textAlign: 'center',
                                        textAlignLast: 'center'
                                    }}
                                >
                                    <option value="">
                                        { }
                                    </option>
                                    {Array.from({ length: 11 }, (_, i) => {
                                        const hour = i + 8;
                                        const timeValue = `${hour.toString().padStart(2, '0')}:00`;
                                        const isDisabled = formDetails.start && timeValue <= formDetails.start;
                                        return (
                                            <option key={timeValue} value={timeValue} disabled={isDisabled}>
                                                {timeValue}
                                            </option>
                                        );
                                    })}
                                </Input>
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Name" : "Ime"}
                                </Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={formDetails.name}
                                    onChange={handleInputChange}
                                    className={errors.name ? "input-error" : ""}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                   Email
                                </Label>
                                <Input
                                    type="email"
                                    name="guestEmail"
                                    value={formDetails.guestEmail}
                                    onChange={handleInputChange}
                                    className={errors.guestEmail ? "input-error" : ""}
                                    required
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-12">
                            <FormGroup>
                                <Label>{selectedLanguage === "EN" ? "Note" : "Napomena"}</Label>
                                <textarea
                                    name="notes"
                                    className="form-control input-left"
                                    value={formDetails.notes}
                                    onChange={handleInputChange}
                                    placeholder={selectedLanguage === "EN" ? "Add information about seating preferences" : "Dodajte informacije o preferencijama za sedenje"}
                                    rows="2"
                                    cols="50"
                                />

                            </FormGroup>
                        </div>
                    </div>
                    {errors.message && (
                        <div className="mb-3"
                            style={{
                                fontSize: "16px",
                                fontFamily: "jura-light",       // Text color
                                textAlign: "center",
                                color: "red",  // Centers the text horizontally
                            }}>
                            {errors.message}
                        </div>
                    )}
                    <div className="terms-pricing-links mb-3">
                        <div className="text-center">
                            <p style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                                {selectedLanguage === "EN"
                                    ? "By reserving, you agree to our:"
                                    : "Rezervacijom se slažete sa našim:"
                                }
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                                <span
                                    onClick={() => setIsTermsModalOpen(true)}
                                    style={{
                                        color: '#0d7248',
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#16a085'}
                                    onMouseLeave={(e) => e.target.style.color = '#0d7248'}
                                >
                                    {selectedLanguage === "EN" ? "Terms & Conditions" : "Uslovima korišćenja"}
                                </span>
                                <span style={{ color: '#ccc' }}>|</span>
                                <span
                                    onClick={() => setIsPricingModalOpen(true)}
                                    style={{
                                        color: '#0d7248',
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#16a085'}
                                    onMouseLeave={(e) => e.target.style.color = '#0d7248'}
                                >
                                    {selectedLanguage === "EN" ? "Pricing" : "Cenovnikom"}
                                </span>
                            </div>
                        </div>
                    </div>
                    <FormGroup>
                        <div className="row">
                            <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                <button
                                    className="model-btn-cancel btn btn-secondary py-1 px-5"
                                    onClick={toggleModal}
                                    type="button"
                                >
                                    {selectedLanguage === "EN" ? "Cancel" : "Otkaži"}
                                </button>
                            </div>
                            <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                <button
                                    className="model-btn btn btn-primary py-1 px-5"
                                    onClick={handleSubmit}
                                >
                                    {selectedLanguage === "EN" ? "Send" : "Pošalji"}
                                </button>
                            </div>
                        </div>
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
        <TermsModal
            isOpen={isTermsModalOpen}
            toggle={() => setIsTermsModalOpen(false)}
        />
        <PricingModal
            isOpen={isPricingModalOpen}
            toggle={() => setIsPricingModalOpen(false)}
        />
        </>
    )
}

export default GuestReservationModal;